import React from 'react';
import styled from 'styled-components';
import { Title } from '@vds/typography';
import { connect } from 'react-redux';
import  Loader  from '../common/loader/loader';
import CompassMapContainer from '../map/index';
import Address from '../address';
import Legend from '../legend';
import { coverageDetails,invokeHereMapScript } from './actions';
import loadjs from 'loadjs';
const MainWrapper = styled.div`
  position:relative;
  #section-title {
    margin-bottom: 1rem;
  }
`;

const AddressLegendWrapper = styled.div`
  #address-wrapper, 
  #legend-wrapper {
    display: inline-block;
    width: 50%;
  }
  margin-bottom: 2rem;
`;

const MapWrapper = styled.div`
  border: 2px dashed cyan;
`;

class CompassApp extends React.Component {
  componentDidMount() {
    loadjs('https://js.api.here.com/v3/3.1/mapsjs-harp.js');
       invokeHereMapScript();  
  coverageDetails(this.props.dispatch);
}
render() {
  return (<>      
    {this.props.longitude && this.props.latitude  && <MainWrapper>
      <Loader active={false} />
      <>
      {this.props.coords && this.props.coords.length != 0 ? <Title id="section-title">Here are the coverage areas in your home.</Title> : <Title id="section-title">Here are the 5G antennas in your area.</Title>}
      <AddressLegendWrapper>
        <div id="address-wrapper">
        {this.props.serviceAddress ?
        <Address serviceAddress={this.props.serviceAddress}/> : this.props.address && <Address address={this.props.address}/>
          }
        </div>
        <div id="legend-wrapper">
          <Legend coords={this.props.coords}/>
        </div>
      </AddressLegendWrapper></>
      <CompassMapContainer id="myMap"/>
   </MainWrapper>}
   </>
  );
}


}

const mapStateToProps = (state) => {
  return {
    address: state.compassApp.address,
    loaderStatus: state.loader.loaderStatus,
    longitude:state.compassApp.lgt,
    latitude:state.compassApp.lat,
    coords:state.compassApp.coords,
    serviceAddress:state.compassApp.serviceAddress
  };
};


export default connect(mapStateToProps)(CompassApp);
